<template>
  <div class="app-search-index">
    <component
      v-for="(item,index) in searchArr"
      :key="index"
      :is="item.componentType"
      v-model="initArrData[index]"
      :search-list="item.selectValue"
      :type="item.searchType"
      :searchStyle="item.searchStyle"
      :time="timeType"
      :date-type-def="dateType"
      :status-type-def="statusTypeDef"
      :class-date="classDate"
      :placeholder="item.placeholder"
      :label="item.label"
      :size="schoolCenter ? '' : 'small'"
      class="search_box"
      @searchColumn="search"
    />

    <el-button
      v-if="(schoolCenter && !hasSearchColumn && searchArr.length > 0) || (!schoolCenter && searchArr.length > 0)"
      slot="append"
      icon="el-icon-search"
      size="small"
      class="list-header__button"
      @click="search"
    />
  </div>
</template>

<script>
/**
 * 全局搜索
 *
 * @author  suyanping
 */
import AppSearchAddress from './AppSearchAddress';
import AppSearchColumn from './AppSearchColumn';
import AppSearchDate from './AppSearchDate';
import AppSearchStatus from './AppSearchStatus';
import AppSearchStatusString from './AppSearchStatusString';
import AppSearchCascader from './AppSearchCascader';

export default {
  name: 'AppSearch',

  components: {
    AppSearchAddress,
    AppSearchColumn,
    AppSearchDate,
    AppSearchStatus,
    AppSearchStatusString,
    AppSearchCascader,
  },

  props: {
    searchArr: {
      type: Array,
      default: () => [],
    },
    searchCall: {
      type: Function,
      default: null,
    },
    statusTypeDef: {
      type: String,
      default: ''
    },
    dateType: {
      type: String,
      default: ''
    },
    timeType: {
      type: String,
      default: '',
    },
    classDate: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default: () => null,
    },
    label: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      initObj: {
        AppSearchAddress: '',
        AppSearchColumn: '',
        AppSearchDate: '',
        AppSearchStatus: '',
        AppSearchCascader: {},
      },

      initArrData: [],

      schoolCenter: this.$store.state.from === 'schoolCenter',
      hasSearchColumn: this.searchArr.some(item => item.componentType === 'AppSearchColumn')
    };
  },

  created() {
    this.getInitData();

    this.firstTimeRedirect();
  },

  methods: {
    getInitData() {
      this.initArrData = this.searchArr.map(
        item => this.initObj[item.componentType],
      );
    },

    /**
     * 第一次进入页面时
     * 若url中无指定page或per_page参数，重定向至默认的page和per_page参数
     */
    firstTimeRedirect() {
      const { page = 1, per_page = 10 } = this.$route.query;

      this.$router.replace({
        query: {
          ...this.$route.query,
          page,
          per_page,
        },
      });
    },

    search() {
      const { per_page } = this.$route.query;

      const searchArr = this.initArrData.filter(item => item);

      const order = this.order ? { [`order[${this.order.type}]`]: this.order.name } : null;

      const query = {
        page: 1,
        per_page,
        ...order
      };
      if (this.$route.query['equal[id]']) {
        query['equal[id]'] = this.$route.query['equal[id]'];
      }
      const data = searchArr.reduce(
        (acc, item) => {
          const isObj = item instanceof Object;

          if (isObj) {
            // eslint-disable-next-line
            acc = {
              ...acc,
              ...item,
            };
          }

          if (!isObj) {
            const urlData = item.split(':');

            const value = this.getValue(urlData);

            acc[urlData[0]] = value;
          }

          return acc;
        },
        { ...query },
      );

      if (this.searchCall) {
        this.searchCall(searchArr)
        return
      }
      this.$router.push({ query: data });
      this.$emit('search', data);
      this.$emit('searchType', data);
      this.$emit('search-name', searchArr);
    },

    getValue(data) {
      return data.reduce((acc, item, index) => {
        if (index > 1) {
          // eslint-disable-next-line
          acc = `${acc}:${item}`;
        }

        return acc;
      }, data[1]);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-search-index {
  display: inline-block;

  /deep/ .list-header__button {
    display: inline-flex;
    margin: 0 0 0 21px;
  }
}
.school-center-theme {
  .app-search-column {
    margin-right: 0;

    /deep/ .list-header__input {
      width: 519px;

      /deep/ .el-input-group__prepend {
        background: none;
      }
      /deep/ .el-select {
        width: 144px !important;
      }
    }
  }
}
.search_box {
  margin: 5px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/AppSearch/index.vue